'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _Snackbar = require('./Snackbar');

var _Snackbar2 = _interopRequireDefault(_Snackbar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Snackbar2.default;


/*****************
 ** WEBPACK FOOTER
 ** ./~/material-ui/Snackbar/index.js
 ** module id = 1106
 ** module chunks = 0
 **/